import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Button, Dropdown, Avatar, Space } from 'antd';
import {
  Bars3Icon,
  XMarkIcon,
  Cog6ToothIcon,
  ArrowRightStartOnRectangleIcon,
} from '@heroicons/react/24/outline';
import { UserIcon } from '@heroicons/react/24/solid';
import type { MenuProps } from 'antd';
import { useAuth } from 'hooks/useAuth';
import { USER_ROLE_LABELS } from 'utils/constants';
import styles from './Header.module.css'; 

const { Header: AntHeader } = Layout;

interface HeaderProps {
  collapsed: boolean;
  onToggle: () => void;
}

const Header: React.FC<HeaderProps> = ({ collapsed, onToggle }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'user-info',
      label: (
        <div className={styles.userInfo}>
          <div className={styles.userName}>{user?.email}</div>
          <div className={styles.userRole}>{user?.role ? USER_ROLE_LABELS[user.role] : ''}</div>        </div>
      ),
      disabled: true,
    },
    { type: 'divider' },
    {
      key: 'settings',
      icon: <span className="menu-icon"><Cog6ToothIcon /></span>,
      label: 'Настройки',
      onClick: () => navigate('/users'),
    },
    { type: 'divider' },
    {
      key: 'logout',
      icon: <span className="menu-icon"><ArrowRightStartOnRectangleIcon /></span>,
      label: 'Выйти',
      danger: true,
      onClick: handleLogout,
    },
  ];

  return (
    <AntHeader className={styles.header}>
      <div className={styles.headerLeft}>
        <Button
          type="text"
          icon={
            <span className="trigger-icon">
              {collapsed ? <Bars3Icon /> : <XMarkIcon />}
            </span>
          }
          onClick={onToggle}
          className={styles.trigger}
        />
      </div>

      <div className={styles.headerRight}>
        <Space size="middle">
          <Dropdown
            menu={{ items: userMenuItems }}
            placement="bottomRight"
            trigger={['click']}
          >
            <Button type="text" className={styles.userButton}>
              <Avatar
                size="small"
                icon={<span className="avatar-icon"><UserIcon /></span>}
                style={{ marginRight: 8 }}
              />
              <span className={styles.userNameText}>{user?.email?.split('@')[0]}</span>
            </Button>
          </Dropdown>
        </Space>
      </div>
    </AntHeader>
  );
};

export default Header;